var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2939_38315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2133 18.9624C68.3574 19.1393 70.5445 20.2396 70.1399 23.2254C69.8619 25.2765 68.8807 26.198 67.9614 27.0614C67.2079 27.769 66.4959 28.4376 66.2467 29.6571C66.2201 28.4127 65.6396 27.6272 65.0252 26.796C64.2755 25.7817 63.4755 24.6993 63.5698 22.6315C63.7071 19.6217 66.056 18.9313 67.2133 18.9624Z",
    fill: "url(#paint0_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.336 101.9C55.2136 101.617 53.1395 100.316 53.8226 97.3815C54.2919 95.3655 55.3552 94.5402 56.3516 93.7669C57.1682 93.1332 57.9397 92.5344 58.3024 91.3436C58.2121 92.5851 58.7163 93.4215 59.2499 94.3068C59.901 95.3869 60.5959 96.5397 60.3079 98.5895C59.8886 101.573 57.4852 102.04 56.336 101.9Z",
    fill: "url(#paint1_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8015 21.7828C78.8608 22.2498 80.6885 23.8787 79.525 26.658C78.7256 28.5673 77.5394 29.2034 76.4279 29.7994C75.5169 30.2879 74.6562 30.7495 74.0998 31.8629C74.3962 30.654 74.0387 29.7451 73.6604 28.7831C73.1988 27.6094 72.7062 26.3568 73.3325 24.3839C74.2441 21.5121 76.6917 21.4532 77.8015 21.7828Z",
    fill: "url(#paint2_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8288 99.0795C44.8181 98.5151 43.1513 96.7218 44.5707 94.064C45.5457 92.2382 46.7864 91.7163 47.949 91.2272C48.9018 90.8264 49.8021 90.4477 50.4606 89.3914C50.052 90.5672 50.3225 91.5056 50.6088 92.4988C50.9582 93.7107 51.3311 95.0041 50.5223 96.9094C49.3451 99.6829 46.9028 99.5118 45.8288 99.0795Z",
    fill: "url(#paint3_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2987 27.2265C88.2011 27.9518 89.545 29.9982 87.7017 32.3816C86.4354 34.019 85.125 34.3264 83.8971 34.6145C82.8907 34.8506 81.9399 35.0736 81.1142 36.0051C81.7134 34.9141 81.6034 33.9436 81.4869 32.9165C81.3448 31.6633 81.1932 30.3259 82.3088 28.5823C83.9326 26.0444 86.312 26.621 87.2987 27.2265Z",
    fill: "url(#paint4_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4097 93.6143C35.5794 92.8075 34.4336 90.644 36.4925 88.4441C37.9069 86.9328 39.2404 86.7498 40.4899 86.5783C41.514 86.4378 42.4816 86.305 43.391 85.4551C42.692 86.485 42.7105 87.4616 42.73 88.495C42.7538 89.756 42.7792 91.1018 41.5049 92.7329C39.6499 95.1073 37.3352 94.3098 36.4097 93.6143Z",
    fill: "url(#paint5_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0579 34.9226C95.7418 35.8567 96.5102 38.1813 94.1129 40.0064C92.466 41.2602 91.1206 41.218 89.86 41.1784C88.8269 41.146 87.8506 41.1154 86.812 41.8014C87.6732 40.9027 87.8181 39.9368 87.9714 38.9146C88.1585 37.6673 88.3582 36.3362 89.887 34.9408C92.1125 32.9095 94.2615 34.0823 95.0579 34.9226Z",
    fill: "url(#paint6_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7204 85.8773C28.1273 84.8831 27.5805 82.4967 30.1385 80.9046C31.8959 79.8109 33.2314 79.9793 34.4827 80.137C35.5082 80.2663 36.4772 80.3885 37.5757 79.803C36.6339 80.6169 36.399 81.5649 36.1504 82.5682C35.847 83.7924 35.5232 85.0989 33.8701 86.3446C31.4639 88.158 29.4344 86.7886 28.7204 85.8773Z",
    fill: "url(#paint7_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.55 44.3466C100.969 45.4259 101.11 47.8701 98.3216 49.0126C96.4063 49.7974 95.1177 49.4084 93.9103 49.0439C92.9207 48.7452 91.9857 48.463 90.8049 48.8568C91.8694 48.2116 92.2593 47.3161 92.672 46.3684C93.1755 45.2121 93.713 43.978 95.5508 43.0258C98.2261 41.6398 99.9984 43.3288 100.55 44.3466Z",
    fill: "url(#paint8_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2851 76.3956C22.9695 75.2818 23.059 72.8351 25.9419 71.9594C27.9225 71.3579 29.1689 71.8661 30.3367 72.3424C31.2938 72.7327 32.1982 73.1015 33.4108 72.8202C32.2905 73.3627 31.8182 74.2176 31.3183 75.1223C30.7085 76.2263 30.0576 77.4045 28.1384 78.1799C25.3448 79.3086 23.7389 77.4607 23.2851 76.3956Z",
    fill: "url(#paint9_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.401 54.8562C103.527 56.0071 103.03 58.4044 100.041 58.7864C97.9878 59.0488 96.8438 58.3395 95.7719 57.675C94.8934 57.1303 94.0633 56.6157 92.8208 56.6905C94.016 56.3427 94.6244 55.5787 95.2683 54.7701C96.054 53.7835 96.8925 52.7305 98.9142 52.2865C101.857 51.6401 103.132 53.7303 103.401 54.8562Z",
    fill: "url(#paint10_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4741 65.8155C20.4575 64.6579 21.1772 62.3178 24.1886 62.2182C26.2573 62.1497 27.3297 62.9632 28.3345 63.7255C29.158 64.3502 29.9361 64.9405 31.1801 64.9826C29.9576 65.2167 29.2801 65.9202 28.5632 66.6648C27.6883 67.5733 26.7547 68.5429 24.7002 68.7952C21.7097 69.1624 20.6368 66.9617 20.4741 65.8155Z",
    fill: "url(#paint11_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.417 65.7353C103.24 66.8793 102.14 69.0664 99.1539 68.6618C97.1028 68.3839 96.1813 67.4027 95.3179 66.4833C94.6103 65.7299 93.9417 65.0179 92.7222 64.7686C93.9667 64.742 94.7521 64.1615 95.5833 63.5471C96.5976 62.7975 97.68 61.9974 99.7478 62.0917C102.758 62.2291 103.448 64.578 103.417 65.7353Z",
    fill: "url(#paint12_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.479 54.858C20.7625 53.7356 22.0633 51.6615 24.9979 52.3446C27.0139 52.8139 27.8392 53.8773 28.6124 54.8736C29.2462 55.6902 29.845 56.4618 31.0357 56.8245C29.7943 56.7341 28.9578 57.2383 28.0726 57.7719C26.9924 58.4231 25.8396 59.118 23.7899 58.8299C20.8062 58.4106 20.3394 56.0073 20.479 54.858Z",
    fill: "url(#paint13_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.597 76.3234C100.13 77.3828 98.5006 79.2105 95.7214 78.047C93.812 77.2476 93.1759 76.0614 92.5799 74.9499C92.0914 74.0389 91.6298 73.1782 90.5164 72.6217C91.7253 72.9182 92.6343 72.5607 93.5962 72.1824C94.7699 71.7208 96.0226 71.2281 97.9954 71.8544C100.867 72.7661 100.926 75.2136 100.597 76.3234Z",
    fill: "url(#paint14_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2999 44.3509C23.8643 43.3401 25.6576 41.6734 28.3154 43.0927C30.1412 44.0678 30.6631 45.3085 31.1522 46.4711C31.553 47.4239 31.9317 48.3241 32.988 48.9826C31.8122 48.574 30.8738 48.8446 29.8806 49.1309C28.6687 49.4803 27.3753 49.8531 25.47 49.0444C22.6965 47.8671 22.8676 45.4249 23.2999 44.3509Z",
    fill: "url(#paint15_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1529 85.8208C94.4276 86.7231 92.3811 88.067 89.9977 86.2237C88.3603 84.9575 88.0529 83.647 87.7649 82.4191C87.5288 81.4128 87.3057 80.4619 86.3743 79.6362C87.4653 80.2355 88.4357 80.1254 89.4628 80.009C90.716 79.8669 92.0535 79.7152 93.797 80.8308C96.335 82.4547 95.7584 84.8341 95.1529 85.8208Z",
    fill: "url(#paint16_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7651 34.9318C29.5719 34.1015 31.7355 32.9557 33.9353 35.0146C35.4466 36.429 35.6296 37.7625 35.8011 39.012C35.9417 40.0361 36.0745 41.0037 36.9243 41.9132C35.8944 41.2142 34.9179 41.2326 33.8844 41.2521C32.6234 41.2759 31.2776 41.3013 29.6465 40.027C27.2722 38.172 28.0696 35.8573 28.7651 34.9318Z",
    fill: "url(#paint17_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4568 93.5799C86.5227 94.2638 84.1982 95.0322 82.373 92.6349C81.1192 90.988 81.1614 89.6426 81.201 88.382C81.2334 87.3489 81.264 86.3727 80.578 85.3341C81.4767 86.1953 82.4426 86.3401 83.4648 86.4935C84.7121 86.6806 86.0433 86.8803 87.4387 88.4091C89.4699 90.6345 88.2971 92.7836 87.4568 93.5799Z",
    fill: "url(#paint18_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5022 27.2425C37.4964 26.6494 39.8828 26.1026 41.4748 28.6607C42.5685 30.418 42.4001 31.7535 42.2424 33.0048C42.1131 34.0303 41.9909 34.9994 42.5764 36.0978C41.7625 35.156 40.8145 34.9211 39.8112 34.6725C38.587 34.3691 37.2805 34.0453 36.0348 32.3923C34.2215 29.986 35.5908 27.9565 36.5022 27.2425Z",
    fill: "url(#paint19_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0328 99.0722C76.9535 99.491 74.5093 99.6316 73.3668 96.8436C72.582 94.9283 72.971 93.6397 73.3355 92.4323C73.6342 91.4428 73.9165 90.5077 73.5226 89.327C74.1678 90.3914 75.0633 90.7813 76.011 91.194C77.1673 91.6976 78.4014 92.235 79.3536 94.0729C80.7396 96.7482 79.0506 98.5205 78.0328 99.0722Z",
    fill: "url(#paint20_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9838 21.8072C47.0976 21.4916 49.5443 21.581 50.42 24.464C51.0215 26.4445 50.5133 27.6909 50.037 28.8588C49.6467 29.8159 49.2779 30.7203 49.5592 31.9329C49.0167 30.8125 48.1618 30.3402 47.2571 29.8404C46.1531 29.2305 44.9749 28.5796 44.1995 26.6605C43.0708 23.8669 44.9187 22.261 45.9838 21.8072Z",
    fill: "url(#paint21_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5232 101.923C66.3723 102.049 63.975 101.552 63.593 98.5631C63.3306 96.5099 64.0399 95.3659 64.7045 94.2939C65.2491 93.4154 65.7637 92.5853 65.6889 91.3428C66.0367 92.538 66.8007 93.1464 67.6093 93.7903C68.5959 94.576 69.6489 95.4145 70.0929 97.4362C70.7393 100.379 68.6491 101.654 67.5232 101.923Z",
    fill: "url(#paint22_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5639 18.9962C57.7214 18.9796 60.0615 19.6992 60.1612 22.7106C60.2297 24.7794 59.4162 25.8517 58.6539 26.8565C58.0292 27.68 57.4389 28.4581 57.3967 29.7022C57.1627 28.4796 56.4592 27.8022 55.7146 27.0852C54.8061 26.2104 53.8365 25.2767 53.5842 23.2223C53.217 20.2317 55.4176 19.1588 56.5639 18.9962Z",
    fill: "url(#paint23_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0749 42.8069C63.7472 40.2694 64.7182 37.2441 64.7182 33.996C64.7182 30.7479 63.7472 27.7226 62.0749 25.1851C60.4026 27.7226 59.4316 30.7479 59.4316 33.996C59.4316 37.2441 60.4026 40.2694 62.0749 42.8069Z",
    fill: "url(#paint24_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0749 95.6726C63.7472 93.1351 64.7182 90.1098 64.7182 86.8617C64.7182 83.6136 63.7472 80.5883 62.0749 78.0508C60.4026 80.5883 59.4316 83.6136 59.4316 86.8617C59.4316 90.1098 60.4026 93.1351 62.0749 95.6726Z",
    fill: "url(#paint25_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6358 43.4074C68.9079 41.3891 70.6288 38.7182 71.4695 35.5808C72.3102 32.4434 72.1553 29.2699 71.1967 26.386C68.9246 28.4042 67.2037 31.0751 66.363 34.2126C65.5224 37.35 65.6773 40.5235 66.6358 43.4074Z",
    fill: "url(#paint26_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9532 94.4717C55.2253 92.4535 56.9462 89.7826 57.7869 86.6451C58.6275 83.5077 58.4726 80.3342 57.5141 77.4503C55.242 79.4686 53.5211 82.1395 52.6804 85.2769C51.8397 88.4143 51.9946 91.5878 52.9532 94.4717Z",
    fill: "url(#paint27_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8859 45.1678C73.603 43.8064 75.9565 41.6719 77.5806 38.859C79.2046 36.046 79.8764 32.9406 79.6969 29.9069C76.9798 31.2683 74.6263 33.4027 73.0022 36.2157C71.3782 39.0286 70.7064 42.1341 70.8859 45.1678Z",
    fill: "url(#paint28_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4531 90.9509C47.1701 89.5895 49.5236 87.455 51.1477 84.642C52.7717 81.8291 53.4435 78.7236 53.264 75.6899C50.547 77.0513 48.1934 79.1858 46.5694 81.9988C44.9453 84.8117 44.2736 87.9172 44.4531 90.9509Z",
    fill: "url(#paint29_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5356 47.9682C77.5124 47.3564 80.3382 45.9038 82.6349 43.6071C84.9317 41.3103 86.3843 38.4845 86.9961 35.5077C84.0193 36.1195 81.1935 37.5721 78.8968 39.8689C76.6 42.1657 75.1474 44.9914 74.5356 47.9682Z",
    fill: "url(#paint30_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1538 85.35C40.1306 84.7382 42.9564 83.2856 45.2532 80.9888C47.5499 78.692 49.0025 75.8663 49.6143 72.8895C46.6375 73.5013 43.8117 74.9539 41.515 77.2506C39.2182 79.5474 37.7656 82.3732 37.1538 85.35Z",
    fill: "url(#paint31_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.336 51.6179C80.3697 51.7974 83.4752 51.1256 86.2881 49.5016C89.1011 47.8775 91.2356 45.524 92.597 42.807C89.5633 42.6275 86.4578 43.2992 83.6448 44.9233C80.8319 46.5473 78.6974 48.9008 77.336 51.6179Z",
    fill: "url(#paint32_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5529 78.0507C34.5867 78.2302 37.6921 77.5585 40.5051 75.9344C43.318 74.3104 45.4525 71.9568 46.8139 69.2398C43.7802 69.0603 40.6747 69.7321 37.8618 71.3561C35.0488 72.9802 32.9143 75.3337 31.5529 78.0507Z",
    fill: "url(#paint33_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0964 55.8679C81.9803 56.8265 85.1538 56.9814 88.2913 56.1407C91.4287 55.3 94.0996 53.5792 96.1178 51.3071C93.2339 50.3485 90.0604 50.1936 86.923 51.0343C83.7855 51.875 81.1147 53.5959 79.0964 55.8679Z",
    fill: "url(#paint34_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.032 69.5506C30.9159 70.5092 34.0894 70.6641 37.2269 69.8234C40.3643 68.9827 43.0352 67.2618 45.0534 64.9897C42.1695 64.0312 38.996 63.8763 35.8586 64.717C32.7212 65.5576 30.0503 67.2785 28.032 69.5506Z",
    fill: "url(#paint35_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6969 60.4288C82.2344 62.1012 85.2597 63.0721 88.5078 63.0721C91.7559 63.0721 94.7812 62.1012 97.3187 60.4289C94.7812 58.7565 91.7559 57.7856 88.5078 57.7856C85.2597 57.7856 82.2344 58.7565 79.6969 60.4288Z",
    fill: "url(#paint36_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8312 60.4288C29.3687 62.1012 32.394 63.0721 35.6421 63.0721C38.8902 63.0721 41.9155 62.1012 44.453 60.4289C41.9155 58.7565 38.8902 57.7856 35.6421 57.7856C32.394 57.7856 29.3687 58.7565 26.8312 60.4288Z",
    fill: "url(#paint37_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0964 64.9897C81.1147 67.2618 83.7856 68.9827 86.923 69.8234C90.0604 70.6641 93.2339 70.5092 96.1178 69.5506C94.0996 67.2785 91.4287 65.5576 88.2913 64.717C85.1538 63.8763 81.9803 64.0312 79.0964 64.9897Z",
    fill: "url(#paint38_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.032 51.3071C30.0503 53.5792 32.7212 55.3001 35.8586 56.1407C38.9961 56.9814 42.1696 56.8265 45.0534 55.868C43.0352 53.5959 40.3643 51.875 37.2269 51.0343C34.0894 50.1936 30.9159 50.3485 28.032 51.3071Z",
    fill: "url(#paint39_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3295 69.253C78.6917 71.9657 80.8266 74.316 83.6395 75.9383C86.4523 77.5607 89.5571 78.2326 92.5899 78.0547C91.2277 75.342 89.0928 72.9918 86.28 71.3694C83.4671 69.747 80.3623 69.0751 77.3295 69.253Z",
    fill: "url(#paint40_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5481 42.8476C32.9103 45.5603 35.0452 47.9106 37.858 49.5329C40.6709 51.1553 43.7757 51.8272 46.8085 51.6493C45.4463 48.9366 43.3114 46.5863 40.4985 44.964C37.6857 43.3416 34.5809 42.6697 31.5481 42.8476Z",
    fill: "url(#paint41_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5314 72.9028C75.1451 75.8757 76.599 78.6984 78.8961 80.9935C81.1932 83.2886 84.0183 84.7412 86.9938 85.3543C86.3801 82.3814 84.9262 79.5587 82.6291 77.2636C80.332 74.9685 77.5069 73.5159 74.5314 72.9028Z",
    fill: "url(#paint42_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1442 35.548C37.7579 38.5209 39.2118 41.3436 41.5089 43.6387C43.806 45.9338 46.6311 47.3864 49.6066 47.9995C48.9929 45.0267 47.539 42.2039 45.2419 39.9088C42.9449 37.6138 40.1197 36.1611 37.1442 35.548Z",
    fill: "url(#paint43_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.884 75.704C70.7074 78.7344 71.3811 81.8372 73.0059 84.6487C74.6307 87.4601 76.9837 89.5944 79.6991 90.9568C79.8757 87.9264 79.202 84.8235 77.5772 82.0121C75.9524 79.2007 73.5994 77.0664 70.884 75.704Z",
    fill: "url(#paint44_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.439 29.9456C44.2623 32.976 44.936 36.0788 46.5608 38.8902C48.1857 41.7017 50.5386 43.836 53.254 45.1983C53.4306 42.1679 52.7569 39.0651 51.1321 36.2537C49.5073 33.4422 47.1543 31.3079 44.439 29.9456Z",
    fill: "url(#paint45_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.636 77.4658C65.681 80.3472 65.5287 83.5187 66.3705 86.6549C67.2123 89.791 68.9327 92.4616 71.2029 94.4803C72.1579 91.5989 72.3102 88.4274 71.4684 85.2912C70.6266 82.1551 68.9062 79.4845 66.636 77.4658Z",
    fill: "url(#paint46_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9351 26.422C51.9801 29.3035 51.8279 32.4749 52.6696 35.6111C53.5114 38.7473 55.2318 41.4178 57.502 43.4365C58.457 40.5551 58.6093 37.3836 57.7675 34.2475C56.9257 31.1113 55.2054 28.4408 52.9351 26.422Z",
    fill: "url(#paint47_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3794 17.6976C61.1575 19.7167 61.8779 21.4288 62.0159 22.0325C62.9879 19.7661 62.73 20.7606 64.7778 17.3648C66.416 14.6482 66.0837 12.0365 65.7127 11.0703C65.4079 10.3431 64.5265 8.59378 63.4394 7.41472C62.3522 6.23565 61.7431 4.26247 61.5744 3.42326C61.3297 5.38484 60.8282 6.6775 59.7899 7.97155C58.9594 9.00679 58.3267 10.6909 58.1143 11.4036C57.7951 12.6603 57.6014 15.6786 59.3794 17.6976Z",
    fill: "url(#paint48_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3794 114.089C61.1575 116.109 61.8779 117.821 62.0159 118.424C62.9879 116.158 62.73 117.152 64.7778 113.757C66.416 111.04 66.0837 108.428 65.7127 107.462C65.4079 106.735 64.5265 104.986 63.4394 103.807C62.3522 102.627 61.7431 100.654 61.5744 99.8151C61.3297 101.777 60.8282 103.069 59.7899 104.363C58.9594 105.399 58.3267 107.083 58.1143 107.795C57.7951 109.052 57.6014 112.07 59.3794 114.089Z",
    fill: "url(#paint49_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6615 18.4937C71.8564 20.9041 72.1091 22.7444 72.0862 23.3632C73.6116 21.4256 73.1051 22.3194 75.962 19.5693C78.2476 17.3693 78.6025 14.7606 78.4942 13.7313C78.388 12.95 77.9894 11.0322 77.2445 9.6119C76.4995 8.19164 76.4218 6.12802 76.4761 5.27374C75.732 7.10516 74.9131 8.22397 73.5753 9.20522C72.5051 9.99021 71.4581 11.4532 71.0684 12.0866C70.4349 13.2179 69.4665 16.0832 70.6615 18.4937Z",
    fill: "url(#paint50_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7135 111.601C46.9084 114.011 47.1611 115.852 47.1382 116.471C48.6636 114.533 48.1571 115.427 51.014 112.677C53.2996 110.477 53.6545 107.868 53.5462 106.839C53.44 106.057 53.0414 104.14 52.2965 102.719C51.5515 101.299 51.4738 99.2354 51.5281 98.3811C50.784 100.212 49.9651 101.331 48.6273 102.313C47.5571 103.098 46.5101 104.561 46.1204 105.194C45.4869 106.325 44.5185 109.191 45.7135 111.601Z",
    fill: "url(#paint51_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3531 22.1825C81.8834 24.8201 81.6512 26.6631 81.4689 27.2549C83.4438 25.7781 82.7233 26.5104 86.1946 24.5934C88.9717 23.0599 89.9897 20.632 90.1515 19.6097C90.2512 18.8275 90.3625 16.8719 90.0106 15.3072C89.6586 13.7425 90.1176 11.7291 90.3911 10.918C89.1984 12.4944 88.1178 13.3632 86.5716 13.9647C85.3347 14.446 83.9448 15.5882 83.4044 16.0991C82.4997 17.0279 80.8227 19.5449 81.3531 22.1825Z",
    fill: "url(#paint52_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1572 105.66C33.6876 108.298 33.4554 110.141 33.273 110.733C35.248 109.256 34.5275 109.988 37.9988 108.071C40.7759 106.538 41.7938 104.11 41.9557 103.088C42.0554 102.305 42.1667 100.35 41.8147 98.785C41.4627 97.2204 41.9218 95.2069 42.1953 94.3958C41.0026 95.9722 39.922 96.841 38.3758 97.4425C37.1389 97.9238 35.7489 99.066 35.2086 99.5769C34.3038 100.506 32.6269 103.023 33.1572 105.66Z",
    fill: "url(#paint53_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7256 28.5129C90.5552 31.1978 89.854 32.9179 89.5247 33.4424C91.8145 32.5271 90.929 33.0479 94.7782 32.0947C97.8576 31.3322 99.4692 29.2505 99.8901 28.305C100.189 27.5752 100.803 25.715 100.868 24.1126C100.933 22.5101 101.897 20.6841 102.371 19.9714C100.811 21.1854 99.5424 21.7449 97.8933 21.9258C96.5739 22.0705 94.9357 22.814 94.2816 23.1677C93.1672 23.8307 90.896 25.8279 90.7256 28.5129Z",
    fill: "url(#paint54_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5663 96.6723C22.3959 99.3572 21.6947 101.077 21.3654 101.602C23.6552 100.686 22.7697 101.207 26.6189 100.254C29.6983 99.4916 31.31 97.4099 31.7309 96.4643C32.0296 95.7346 32.6433 93.8744 32.7083 92.272C32.7733 90.6695 33.7378 88.8435 34.2119 88.1308C32.6518 89.3448 31.3832 89.9043 29.734 90.0852C28.4147 90.2299 26.7765 90.9734 26.1223 91.3271C25.008 91.9901 22.7367 93.9873 22.5663 96.6723Z",
    fill: "url(#paint55_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1403 37.0533C97.2808 39.6027 96.1583 41.0827 95.7045 41.504C98.1532 41.2126 97.1631 41.4865 101.128 41.562C104.3 41.6225 106.395 40.0288 107.046 39.2244C107.524 38.5969 108.598 36.9589 109.076 35.4279C109.553 33.8968 110.957 32.3827 111.6 31.817C109.779 32.5859 108.408 32.7979 106.769 32.5458C105.457 32.3441 103.682 32.6383 102.959 32.8106C101.711 33.1626 98.9999 34.504 98.1403 37.0533Z",
    fill: "url(#paint56_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6626 85.2493C13.8031 87.7987 12.6805 89.2787 12.2267 89.7C14.6754 89.4086 13.6853 89.6825 17.65 89.758C20.8218 89.8185 22.9174 88.2248 23.5687 87.4205C24.0461 86.7929 25.1203 85.1549 25.5978 83.6239C26.0754 82.0928 27.4796 80.5787 28.122 80.013C26.3009 80.7819 24.9307 80.9939 23.2909 80.7418C21.9791 80.5401 20.2042 80.8343 19.4808 81.0066C18.2329 81.3586 15.5221 82.7 14.6626 85.2493Z",
    fill: "url(#paint57_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.092 47.2219C101.602 49.4619 100.135 50.6009 99.5872 50.8905C102.028 51.2427 101.001 51.251 104.811 52.3502C107.859 53.2294 110.295 52.2325 111.133 51.6241C111.756 51.1414 113.218 49.8373 114.075 48.4821C114.933 47.1268 116.681 46.0277 117.448 45.6475C115.49 45.9189 114.112 45.769 112.593 45.1011C111.378 44.5668 109.588 44.3916 108.844 44.3708C107.548 44.3878 104.582 44.9818 103.092 47.2219Z",
    fill: "url(#paint58_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98466 72.17C8.49462 74.41 7.02728 75.5491 6.47986 75.8386C8.92058 76.1908 7.8933 76.1992 11.7034 77.2983C14.7515 78.1776 17.1881 77.1806 18.0254 76.5722C18.6489 76.0896 20.1105 74.7855 20.968 73.4302C21.8255 72.0749 23.5738 70.9758 24.3408 70.5956C22.3827 70.867 21.0043 70.7171 19.4856 70.0492C18.2707 69.5149 16.4802 69.3397 15.7368 69.3189C14.4403 69.3359 11.4747 69.9299 9.98466 72.17Z",
    fill: "url(#paint59_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.243 58.3255C103.224 60.1036 101.512 60.824 100.908 60.962C103.175 61.9339 102.18 61.6761 105.576 63.7239C108.293 65.3621 110.904 65.0298 111.87 64.6588C112.598 64.354 114.347 63.4726 115.526 62.3855C116.705 61.2983 118.678 60.6891 119.518 60.5204C117.556 60.2758 116.263 59.7743 114.969 58.736C113.934 57.9055 112.25 57.2728 111.537 57.0603C110.28 56.7412 107.262 56.5475 105.243 58.3255Z",
    fill: "url(#paint60_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85129 58.3256C6.83225 60.1037 5.1201 60.8241 4.51641 60.9621C6.78279 61.934 5.78837 61.6762 9.18416 63.724C11.9008 65.3622 14.5124 65.0299 15.4786 64.6589C16.2059 64.3541 17.9552 63.4727 19.1342 62.3856C20.3133 61.2984 22.2865 60.6892 23.1257 60.5205C21.1641 60.2759 19.8714 59.7744 18.5774 58.7361C17.5421 57.9055 15.858 57.2729 15.1454 57.0604C13.8886 56.7413 10.8703 56.5475 8.85129 58.3256Z",
    fill: "url(#paint61_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.447 69.6076C102.037 70.8025 100.196 71.0553 99.5776 71.0323C101.515 72.5577 100.621 72.0513 103.371 74.9082C105.572 77.1937 108.18 77.5486 109.209 77.4404C109.991 77.3342 111.909 76.9356 113.329 76.1906C114.749 75.4457 116.813 75.3679 117.667 75.4222C115.836 74.6782 114.717 73.8592 113.736 72.5214C112.951 71.4512 111.488 70.4042 110.854 70.0145C109.723 69.381 106.858 68.4127 104.447 69.6076Z",
    fill: "url(#paint62_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3398 44.6596C8.92933 45.8545 7.08906 46.1073 6.47023 46.0843C8.40783 47.6097 7.51402 47.1033 10.2641 49.9602C12.4641 52.2458 15.0728 52.6006 16.1021 52.4924C16.8835 52.3862 18.8013 51.9876 20.2215 51.2427C21.6418 50.4977 23.7054 50.42 24.5597 50.4743C22.7283 49.7302 21.6095 48.9112 20.6282 47.5735C19.8432 46.5032 18.3802 45.4563 17.7468 45.0666C16.6155 44.4331 13.7502 43.4647 11.3398 44.6596Z",
    fill: "url(#paint63_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.758 80.2992C98.1207 80.8295 96.2777 80.5974 95.6859 80.415C97.1627 82.3899 96.4304 81.6694 98.3473 85.1408C99.8809 87.9178 102.309 88.9358 103.331 89.0977C104.113 89.1973 106.069 89.3087 107.634 88.9567C109.198 88.6047 111.212 89.0637 112.023 89.3372C110.446 88.1446 109.578 87.0639 108.976 85.5178C108.495 84.2808 107.353 82.8909 106.842 82.3506C105.913 81.4458 103.396 79.7689 100.758 80.2992Z",
    fill: "url(#paint64_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2805 32.1034C14.6429 32.6337 12.7999 32.4015 12.2081 32.2192C13.6849 34.1941 12.9526 33.4736 14.8696 36.9449C16.4031 39.722 18.831 40.74 19.8533 40.9018C20.6355 41.0015 22.5911 41.1128 24.1558 40.7609C25.7205 40.4089 27.7339 40.8679 28.545 41.1414C26.9686 39.9487 26.0998 38.8681 25.4983 37.3219C25.017 36.085 23.8748 34.6951 23.3639 34.1547C22.4351 33.25 19.9181 31.573 17.2805 32.1034Z",
    fill: "url(#paint65_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4279 89.6717C91.743 89.5013 90.0228 88.8001 89.4984 88.4708C90.4137 90.7606 89.8929 89.8751 90.846 93.7243C91.6086 96.8037 93.6903 98.4154 94.6358 98.8363C95.3656 99.135 97.2258 99.7487 98.8282 99.8137C100.431 99.8787 102.257 100.843 102.969 101.317C101.755 99.7572 101.196 98.4886 101.015 96.8394C100.87 95.5201 100.127 93.8819 99.7731 93.2277C99.1101 92.1134 97.1129 89.8421 94.4279 89.6717Z",
    fill: "url(#paint66_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2685 21.5125C23.5836 21.3421 21.8635 20.6409 21.3391 20.3116C22.2544 22.6014 21.7335 21.7159 22.6867 25.5651C23.4492 28.6445 25.5309 30.2561 26.4765 30.677C27.2062 30.9758 29.0664 31.5895 30.6689 31.6545C32.2713 31.7194 34.0973 32.6839 34.81 33.1581C33.596 31.598 33.0365 30.3293 32.8557 28.6802C32.7109 27.3608 31.9674 25.7227 31.6137 25.0685C30.9507 23.9541 28.9535 21.6829 26.2685 21.5125Z",
    fill: "url(#paint67_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8874 97.0865C83.338 96.227 81.858 95.1044 81.4367 94.6506C81.7282 97.0993 81.4542 96.1092 81.3787 100.074C81.3183 103.246 82.9119 105.341 83.7163 105.993C84.3439 106.47 85.9818 107.544 87.5129 108.022C89.0439 108.499 90.558 109.903 91.1237 110.546C90.3549 108.725 90.1428 107.355 90.3949 105.715C90.5966 104.403 90.3024 102.628 90.1301 101.905C89.7781 100.657 88.4368 97.946 85.8874 97.0865Z",
    fill: "url(#paint68_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6915 13.6088C35.1421 12.7493 33.6621 11.6268 33.2408 11.1729C33.5323 13.6216 33.2583 12.6315 33.1828 16.5963C33.1223 19.7681 34.716 21.8636 35.5204 22.5149C36.148 22.9923 37.7859 24.0665 39.3169 24.5441C40.848 25.0216 42.3621 26.4258 42.9278 27.0682C42.1589 25.2471 41.9469 23.8769 42.199 22.2371C42.4007 20.9253 42.1065 19.1505 41.9342 18.427C41.5822 17.1791 40.2409 14.4683 37.6915 13.6088Z",
    fill: "url(#paint69_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7189 102.038C73.4788 100.548 72.3398 99.0808 72.0503 98.5333C71.698 100.974 71.6897 99.9468 70.5906 103.757C69.7113 106.805 70.7083 109.242 71.3167 110.079C71.7993 110.702 73.1034 112.164 74.4587 113.021C75.8139 113.879 76.9131 115.627 77.2932 116.394C77.0219 114.436 77.1717 113.058 77.8396 111.539C78.374 110.324 78.5492 108.534 78.57 107.79C78.5529 106.494 77.9589 103.528 75.7189 102.038Z",
    fill: "url(#paint70_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7708 8.93089C48.5307 7.44084 47.3917 5.9735 47.1022 5.42608C46.75 7.8668 46.7416 6.83952 45.6425 10.6496C44.7632 13.6977 45.7602 16.1343 46.3686 16.9716C46.8512 17.5952 48.1553 19.0567 49.5106 19.9142C50.8659 20.7717 51.965 22.52 52.3451 23.287C52.0738 21.3289 52.2236 19.9505 52.8916 18.4318C53.4259 17.2169 53.6011 15.4264 53.6219 14.683C53.6049 13.3865 53.0108 10.4209 50.7708 8.93089Z",
    fill: "url(#paint71_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9633 7.28296C69.6279 9.23998 68.8119 11.1323 68.6958 11.8338C68.5736 10.8267 67.9874 8.4463 66.6205 6.98132C65.2537 5.51635 64.5534 3.16969 64.3134 2.19569C64.2429 1.40268 64.8837 0.133717 66.0006 0.348091C67.1176 0.562465 67.2981 1.71066 67.2487 2.25795C67.1807 2.70888 67.0874 3.85277 67.2579 4.82088C67.4284 5.78899 67.8363 7.02907 68.0189 7.52809C68.2422 8.20196 68.6901 10.0065 68.6958 11.8338C68.9132 10.0048 70.1399 7.69391 70.7261 6.76711C70.9029 6.52266 71.3709 5.84413 71.8283 5.08562C72.2857 4.32711 72.4644 3.22188 72.4966 2.76408C72.6382 2.12312 73.2092 0.907608 74.3609 1.17319C75.5125 1.43876 75.4678 2.8518 75.3014 3.52512C75.1618 3.9623 74.2988 5.32593 71.9633 7.28296Z",
    fill: "url(#paint72_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7852 4.71839C69.6509 6.68324 68.9826 9.17922 68.7902 10.1816C68.9876 7.99241 68.6362 6.92276 68.3856 5.03731C68.1851 3.52896 68.3434 2.37527 68.419 1.98147L68.5413 1.6152C69.4395 0.184097 70.5276 0.548828 70.9594 0.910082C71.374 1.36083 71.9196 2.75355 70.7852 4.71839Z",
    fill: "url(#paint73_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0802 116.812C54.3871 114.821 55.1757 112.918 55.2816 112.214C55.4184 113.22 56.0389 115.591 57.4268 117.036C58.8148 118.481 59.5489 120.818 59.8029 121.788C59.8849 122.58 59.2626 123.858 58.1427 123.66C57.0227 123.462 56.8256 122.316 56.8671 121.768C56.9285 121.316 57.0053 120.171 56.8208 119.206C56.6363 118.24 56.2105 117.006 56.0207 116.51C55.7877 115.839 55.3137 114.041 55.2816 112.214C55.0907 114.046 53.8975 116.375 53.3248 117.31C53.1515 117.557 52.6934 118.242 52.247 119.007C51.8007 119.772 51.638 120.88 51.6124 121.338C51.4801 121.981 50.9267 123.205 49.7713 122.956C48.6159 122.707 48.6403 121.293 48.7969 120.618C48.9301 120.179 49.7733 118.803 52.0802 116.812Z",
    fill: "url(#paint74_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2953 119.359C54.4011 117.378 55.0333 114.873 55.2111 113.868C55.0453 116.06 55.4123 117.124 55.6901 119.006C55.9124 120.511 55.7708 121.667 55.7009 122.062L55.5839 122.43C54.7065 123.874 53.6132 123.525 53.1763 123.17C52.7552 122.725 52.1895 121.34 53.2953 119.359Z",
    fill: "url(#paint75_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7867 11.7093C83.0243 12.9952 81.7463 14.6118 81.4526 15.2594C81.5952 14.255 81.6451 11.8039 80.704 10.0351C79.7628 8.26629 79.6938 5.81835 79.7141 4.81544C79.8513 4.03119 80.7986 2.97131 81.822 3.46746C82.8454 3.96362 82.7226 5.1194 82.5332 5.63528C82.3509 6.05325 81.9646 7.134 81.8788 8.11325C81.7929 9.09251 81.8659 10.3959 81.9132 10.9252C81.9544 11.6339 81.9201 13.4929 81.4526 15.2594C82.136 13.5489 83.919 11.6343 84.7251 10.8908C84.9592 10.7004 85.5868 10.1662 86.2249 9.55188C86.8631 8.93759 87.3217 7.91628 87.4713 7.48241C87.774 6.89994 88.6402 5.87364 89.6838 6.42824C90.7275 6.98284 90.3186 8.33614 89.9836 8.94346C89.7356 9.32962 88.5491 10.4234 85.7867 11.7093Z",
    fill: "url(#paint76_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3125 8.9272C83.7083 10.5315 82.4167 12.7695 81.9714 13.6879C82.7287 11.6244 82.6661 10.5002 82.912 8.61418C83.1088 7.10533 83.5603 6.03193 83.7352 5.67112L83.9481 5.34897C85.1862 4.19912 86.1428 4.83304 86.4664 5.29373C86.7501 5.83643 86.9167 7.3229 85.3125 8.9272Z",
    fill: "url(#paint77_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2328 112.36C40.9763 111.034 42.2307 109.399 42.515 108.748C42.387 109.754 42.3725 112.206 43.3391 113.961C44.3058 115.716 44.4103 118.162 44.4044 119.165C44.2787 119.952 43.3468 121.025 42.3163 120.544C41.2858 120.062 41.3919 118.905 41.5737 118.386C41.7501 117.966 42.1206 116.88 42.1923 115.899C42.2639 114.919 42.1721 113.617 42.1172 113.088C42.0657 112.38 42.0731 110.521 42.515 108.748C41.8565 110.468 40.1013 112.408 39.3061 113.163C39.0748 113.357 38.4549 113.9 37.8258 114.524C37.1966 115.147 36.7527 116.175 36.6095 116.611C36.3153 117.198 35.464 118.236 34.4124 117.697C33.3608 117.158 33.7502 115.799 34.0763 115.186C34.3187 114.797 35.4893 113.686 38.2328 112.36Z",
    fill: "url(#paint78_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7472 115.135C40.328 113.508 41.5871 111.251 42.019 110.327C41.2916 112.401 41.3705 113.524 41.1519 115.413C40.977 116.925 40.541 118.005 40.3714 118.368L40.1631 118.693C38.9419 119.861 37.9762 119.241 37.646 118.785C37.3544 118.246 37.1663 116.762 38.7472 115.135Z",
    fill: "url(#paint79_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9936 19.568C94.9925 20.0951 93.3397 21.3258 92.8884 21.8753C93.2861 20.9421 93.9687 18.5875 93.5174 16.6353C93.0661 14.6832 93.633 12.3008 93.9122 11.3373C94.2477 10.6153 95.437 9.83671 96.2971 10.5808C97.1572 11.325 96.7395 12.4096 96.4231 12.8589C96.1387 13.2154 95.486 14.1594 95.1496 15.083C94.8132 16.0067 94.5464 17.2846 94.455 17.808C94.3114 18.5033 93.7971 20.29 92.8884 21.8753C93.9912 20.4001 96.209 19.0122 97.18 18.5026C97.4554 18.3793 98.1999 18.0257 98.9753 17.5975C99.7506 17.1693 100.458 16.3015 100.715 15.9211C101.158 15.4368 102.26 14.6697 103.125 15.4755C103.989 16.2814 103.244 17.4827 102.763 17.9826C102.424 18.2914 100.995 19.0409 97.9936 19.568Z",
    fill: "url(#paint80_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2556 16.7579C96.2908 17.8924 94.464 19.7198 93.7962 20.4917C95.0618 18.6945 95.2923 17.5924 96.018 15.8343C96.5985 14.4278 97.3125 13.5078 97.5748 13.2046L97.8639 12.9485C99.3573 12.1583 100.117 13.0182 100.311 13.5469C100.444 14.1446 100.22 15.6235 98.2556 16.7579Z",
    fill: "url(#paint81_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0097 104.481C29.0028 103.911 30.6377 102.656 31.081 102.1C30.6969 103.039 30.0484 105.403 30.5279 107.349C31.0073 109.294 30.475 111.685 30.2097 112.652C29.8848 113.379 28.7068 114.175 27.836 113.443C26.9652 112.711 27.3673 111.621 27.6771 111.167C27.9563 110.806 28.5953 109.853 28.9183 108.925C29.2413 107.996 29.4896 106.715 29.5734 106.19C29.7069 105.493 30.1953 103.699 31.081 102.1C29.9997 103.591 27.8022 105.011 26.8386 105.535C26.5651 105.662 25.8257 106.026 25.0566 106.466C24.2875 106.905 23.5928 107.783 23.3415 108.167C22.9055 108.658 21.8144 109.441 20.9383 108.648C20.0621 107.854 20.7899 106.642 21.2634 106.136C21.5984 105.822 23.0166 105.052 26.0097 104.481Z",
    fill: "url(#paint82_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7884 107.295C27.7365 106.132 29.5367 104.278 30.1933 103.497C28.9538 105.312 28.7393 106.418 28.0391 108.186C27.479 109.601 26.7784 110.531 26.5205 110.838L26.2352 111.098C24.7533 111.91 23.981 111.061 23.7801 110.535C23.6378 109.94 23.8402 108.458 25.7884 107.295Z",
    fill: "url(#paint83_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.752 30.3234C104.717 30.0558 102.802 30.8169 102.224 31.2308C102.85 30.4323 104.118 28.3346 104.188 26.3322C104.257 24.3298 105.421 22.1753 105.94 21.3169C106.451 20.7063 107.801 20.2621 108.44 21.2034C109.078 22.1448 108.394 23.0844 107.972 23.4365C107.605 23.7072 106.73 24.4501 106.166 25.2552C105.602 26.0604 105.014 27.2256 104.79 27.7076C104.471 28.342 103.512 29.9348 102.224 31.2308C103.671 30.0913 106.172 29.3246 107.242 29.0838C107.54 29.036 108.351 28.8871 109.211 28.6742C110.07 28.4612 110.978 27.8061 111.325 27.5051C111.878 27.152 113.141 26.6963 113.768 27.6985C114.394 28.7006 113.364 29.6681 112.77 30.0266C112.362 30.237 110.788 30.591 107.752 30.3234Z",
    fill: "url(#paint84_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.733 27.677C106.541 28.2642 104.304 29.5565 103.459 30.1293C105.146 28.7209 105.654 27.716 106.81 26.2057C107.735 24.9973 108.663 24.2935 108.995 24.0685L109.34 23.896C110.987 23.5192 111.499 24.5465 111.549 25.1072C111.523 25.7191 110.924 27.0897 108.733 27.677Z",
    fill: "url(#paint85_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.244 93.7126C19.2828 93.9363 21.1867 93.1476 21.7588 92.7253C21.1447 93.5328 19.9064 95.6487 19.866 97.6519C19.8257 99.6551 18.6928 101.826 18.1862 102.692C17.6842 103.31 16.3404 103.774 15.6886 102.842C15.0369 101.91 15.7075 100.96 16.1242 100.602C16.4872 100.326 17.3512 99.5706 17.9035 98.7574C18.4558 97.9442 19.0273 96.7705 19.244 96.2853C19.5534 95.6464 20.4895 94.0399 21.7588 92.7253C20.3284 93.8857 17.8383 94.6885 16.772 94.9448C16.4748 94.9969 15.6664 95.1574 14.8098 95.3828C13.9532 95.6082 13.0549 96.2764 12.7128 96.5823C12.1646 96.9434 10.908 97.4173 10.2671 96.4243C9.62606 95.4314 10.6428 94.4491 11.2313 94.082C11.636 93.8657 13.2052 93.489 16.244 93.7126Z",
    fill: "url(#paint86_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.302 96.373C17.4848 95.7541 19.7033 94.4295 20.5398 93.8446C18.8727 95.2773 18.3795 96.2894 17.2455 97.8164C16.3382 99.0379 15.4208 99.7551 15.0922 99.9849L14.7492 100.162C13.1078 100.563 12.5815 99.5432 12.5235 98.9832C12.5402 98.371 13.1193 96.9919 15.302 96.373Z",
    fill: "url(#paint87_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.398 43.2427C111.535 42.1986 109.488 42.4381 108.823 42.6883C109.634 42.0789 111.402 40.3811 111.988 38.4649C112.573 36.5486 114.255 34.7688 114.978 34.074C115.63 33.6165 117.049 33.5369 117.422 34.6114C117.795 35.6859 116.891 36.4163 116.392 36.6472C115.968 36.8138 114.93 37.3049 114.177 37.9366C113.424 38.5683 112.554 39.5416 112.213 39.9492C111.741 40.4796 110.402 41.7698 108.823 42.6883C110.515 41.9621 113.13 41.869 114.226 41.9133C114.526 41.9442 115.348 42.0102 116.233 42.0271C117.119 42.0439 118.165 41.6461 118.578 41.445C119.204 41.2472 120.542 41.134 120.888 42.2641C121.234 43.3943 119.987 44.062 119.321 44.2546C118.873 44.3523 117.26 44.2867 114.398 43.2427Z",
    fill: "url(#paint88_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.03 40.9401C113.761 40.9402 111.265 41.6094 110.301 41.944C112.295 41.0204 113.046 40.1812 114.554 39.0214C115.76 38.0936 116.838 37.6539 117.217 37.5225L117.595 37.4452C119.284 37.5076 119.512 38.6323 119.415 39.1868C119.232 39.7712 118.298 40.9401 116.03 40.9401Z",
    fill: "url(#paint89_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60118 80.7879C12.4785 81.7904 14.5217 81.5214 15.1836 81.2615C14.3814 81.8826 12.6377 83.6058 12.0802 85.5303C11.5228 87.4548 9.86657 89.2588 9.15315 89.964C8.50832 90.4309 7.0903 90.531 6.70198 89.462C6.31365 88.3931 7.2071 87.6496 7.70236 87.4116C8.12442 87.2388 9.15451 86.7328 9.89843 86.0902C10.6424 85.4476 11.4982 84.4619 11.8331 84.0494C12.2973 83.5123 13.6173 82.2028 15.1836 81.2615C13.5015 82.0122 10.8885 82.1431 9.79228 82.1147C9.49175 82.0881 8.66926 82.034 7.78353 82.0299C6.8978 82.0259 5.85715 82.4388 5.44755 82.6458C4.8246 82.8527 3.48818 82.9853 3.12603 81.8602C2.76388 80.7352 4.00021 80.0495 4.66364 79.8473C5.11058 79.7431 6.72382 79.7854 9.60118 80.7879Z",
    fill: "url(#paint90_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00274 83.1138C10.2713 83.0809 12.7571 82.3757 13.7164 82.0272C11.7354 82.9795 10.997 83.8295 9.50637 85.0109C8.31388 85.9561 7.24208 86.4114 6.86519 86.5483L6.48801 86.631C4.79878 86.5931 4.55435 85.4718 4.6433 84.9159C4.81789 84.3289 5.73422 83.1467 8.00274 83.1138Z",
    fill: "url(#paint91_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.477 57.4453C114.982 55.6959 112.943 55.3975 112.235 55.4669C113.177 55.0882 115.324 53.9059 116.385 52.2065C117.447 50.507 119.532 49.2232 120.411 48.7394C121.159 48.466 122.55 48.7565 122.632 49.8909C122.714 51.0252 121.652 51.4968 121.11 51.5907C120.657 51.6418 119.528 51.8477 118.637 52.263C117.746 52.6782 116.654 53.3931 116.219 53.6987C115.626 54.0888 113.999 54.9885 112.235 55.4669C114.058 55.2035 116.608 55.7904 117.655 56.1167C117.937 56.2242 118.713 56.5007 119.564 56.7461C120.416 56.9916 121.529 56.8782 121.98 56.7908C122.636 56.7617 123.958 56.9987 123.999 58.1798C124.041 59.361 122.664 59.6834 121.971 59.697C121.512 59.6753 119.972 59.1947 117.477 57.4453Z",
    fill: "url(#paint92_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.649 55.6436C117.458 55.0564 114.874 55.0569 113.856 55.1305C116.022 54.7546 116.964 54.1383 118.72 53.4082C120.125 52.8242 121.281 52.6785 121.68 52.6496L122.066 52.6729C123.681 53.1702 123.61 54.3156 123.373 54.8261C123.045 55.3433 121.841 56.2307 119.649 55.6436Z",
    fill: "url(#paint93_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53388 66.5879C9.05373 68.3009 11.0969 68.5699 11.8035 68.4902C10.8679 68.8825 8.73761 70.0957 7.70103 71.8103C6.66445 73.525 4.5978 74.8388 3.72617 75.3353C2.98246 75.6195 1.58685 75.3492 1.48843 74.2161C1.39 73.083 2.44542 72.5962 2.98543 72.4944C3.43781 72.4368 4.56378 72.2146 5.44866 71.7864C6.33354 71.3583 7.41535 70.6277 7.84564 70.3159C8.43305 69.9173 10.047 68.994 11.8035 68.4902C9.98447 68.7799 7.42662 68.2301 6.37507 67.9189C6.09166 67.8155 5.31121 67.5503 4.4567 67.3171C3.6022 67.084 2.49013 67.2135 2.04091 67.3074C1.38564 67.3461 0.0604493 67.1282 0.00182098 65.9478C-0.0568073 64.7674 1.31486 64.425 2.00802 64.4014C2.4667 64.4164 4.01403 64.8748 6.53388 66.5879Z",
    fill: "url(#paint94_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38792 68.4208C6.58766 68.9762 9.1713 68.9384 10.1882 68.85C8.02811 69.2572 7.09489 69.8871 5.34929 70.6425C3.95281 71.2468 2.79969 71.4092 2.40021 71.4439L2.01447 71.4261C0.392622 70.9523 0.446727 69.806 0.676512 69.2921C0.997087 68.7702 2.18817 67.8655 4.38792 68.4208Z",
    fill: "url(#paint95_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.78 71.9634C114.823 69.628 112.931 68.8119 112.229 68.6959C113.236 68.5736 115.617 67.9875 117.082 66.6206C118.547 65.2537 120.893 64.5535 121.867 64.3135C122.66 64.243 123.929 64.8838 123.715 66.0007C123.501 67.1176 122.352 67.2981 121.805 67.2488C121.354 67.1808 120.21 67.0874 119.242 67.258C118.274 67.4285 117.034 67.8364 116.535 68.019C115.861 68.2423 114.057 68.6902 112.229 68.6959C114.058 68.9133 116.369 70.14 117.296 70.7262C117.54 70.903 118.219 71.371 118.978 71.8284C119.736 72.2858 120.841 72.4645 121.299 72.4967C121.94 72.6382 123.156 73.2093 122.89 74.361C122.624 75.5126 121.211 75.4678 120.538 75.3015C120.101 75.1619 118.737 74.2989 116.78 71.9634Z",
    fill: "url(#paint96_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.345 70.7853C117.38 69.651 114.884 68.9826 113.882 68.7903C116.071 68.9877 117.14 68.6362 119.026 68.3857C120.534 68.1852 121.688 68.3435 122.082 68.4191L122.448 68.5414C123.879 69.4396 123.514 70.5277 123.153 70.9595C122.702 71.3741 121.31 71.9196 119.345 70.7853Z",
    fill: "url(#paint97_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25116 52.0803C9.24177 54.3871 11.1457 55.1757 11.8488 55.2816C10.8436 55.4184 8.47191 56.0389 7.02686 57.4269C5.58182 58.8148 3.24555 59.549 2.27512 59.803C1.4832 59.8849 0.205107 59.2626 0.403297 58.1427C0.601488 57.0228 1.74695 56.8257 2.2949 56.8671C2.74677 56.9286 3.89189 57.0054 4.85742 56.8208C5.82296 56.6363 7.05701 56.2106 7.55334 56.0208C8.22391 55.7877 10.0218 55.3137 11.8488 55.2816C10.0168 55.0907 7.68846 53.8975 6.75327 53.3248C6.50629 53.1516 5.82106 52.6934 5.05601 52.2471C4.29096 51.8007 3.18326 51.638 2.72504 51.6125C2.08211 51.4802 0.858455 50.9268 1.10734 49.7714C1.35623 48.616 2.76976 48.6403 3.44542 48.7969C3.88458 48.9302 5.26055 49.7734 7.25116 52.0803Z",
    fill: "url(#paint98_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70392 53.2953C6.68496 54.4011 9.19036 55.0333 10.1954 55.2112C8.0036 55.0454 6.93914 55.4123 5.05752 55.6901C3.55222 55.9124 2.39637 55.7708 2.00152 55.7009L1.63352 55.584C0.189563 54.7065 0.538512 53.6133 0.893481 53.1763C1.33819 52.7553 2.72287 52.1896 4.70392 53.2953Z",
    fill: "url(#paint99_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.354 85.7867C111.068 83.0243 109.451 81.7463 108.804 81.4526C109.808 81.5952 112.259 81.6452 114.028 80.704C115.797 79.7629 118.245 79.6938 119.248 79.7142C120.032 79.8513 121.092 80.7986 120.596 81.822C120.1 82.8454 118.944 82.7226 118.428 82.5333C118.01 82.3509 116.929 81.9647 115.95 81.8788C114.971 81.793 113.667 81.866 113.138 81.9132C112.429 81.9545 110.57 81.9201 108.804 81.4526C110.514 82.136 112.429 83.919 113.172 84.7251C113.363 84.9592 113.897 85.5869 114.511 86.225C115.126 86.8631 116.147 87.3218 116.581 87.4714C117.163 87.774 118.189 88.6402 117.635 89.6839C117.08 90.7276 115.727 90.3186 115.12 89.9836C114.734 89.7357 113.64 88.5491 112.354 85.7867Z",
    fill: "url(#paint100_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.136 85.3125C113.532 83.7083 111.294 82.4167 110.375 81.9714C112.439 82.7288 113.563 82.6661 115.449 82.9121C116.958 83.1088 118.031 83.5603 118.392 83.7353L118.714 83.9482C119.864 85.1862 119.23 86.1428 118.769 86.4664C118.227 86.7502 116.74 86.9167 115.136 85.3125Z",
    fill: "url(#paint101_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.703 38.2329C13.0288 40.9763 14.6637 42.2308 15.3155 42.5151C14.3091 42.3871 11.8576 42.3726 10.1026 43.3392C8.34755 44.3059 5.90087 44.4103 4.89777 44.4045C4.11162 44.2787 3.03814 43.3468 3.51944 42.3164C4.00073 41.2859 5.15817 41.392 5.67673 41.5738C6.0973 41.7501 7.18352 42.1207 8.16392 42.1924C9.14431 42.264 10.4465 42.1722 10.975 42.1173C11.6831 42.0658 13.5424 42.0732 15.3155 42.5151C13.5953 41.8565 11.6551 40.1014 10.9 39.3062C10.7063 39.0749 10.163 38.455 9.53951 37.8258C8.91605 37.1967 7.88821 36.7528 7.45222 36.6095C6.86543 36.3154 5.82671 35.4641 6.36615 34.4125C6.90559 33.3609 8.26466 33.7503 8.87677 34.0764C9.26648 34.3187 10.3773 35.4894 11.703 38.2329Z",
    fill: "url(#paint102_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9281 38.7473C10.5555 40.3281 12.8119 41.5872 13.7366 42.0191C11.6624 41.2917 10.5393 41.3706 8.64984 41.152C7.13831 40.9771 6.05848 40.5411 5.69518 40.3714L5.36999 40.1632C4.20234 38.9419 4.82235 37.9763 5.27831 37.6461C5.81685 37.3545 7.30075 37.1664 8.9281 38.7473Z",
    fill: "url(#paint103_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.495 97.9936C103.968 94.9925 102.737 93.3397 102.188 92.8884C103.121 93.2861 105.476 93.9687 107.428 93.5174C109.38 93.0662 111.762 93.633 112.726 93.9122C113.448 94.2477 114.226 95.4371 113.482 96.2972C112.738 97.1573 111.654 96.7395 111.204 96.4231C110.848 96.1388 109.904 95.486 108.98 95.1496C108.056 94.8132 106.779 94.5464 106.255 94.455C105.56 94.3115 103.773 93.7972 102.188 92.8884C103.663 93.9912 105.051 96.209 105.561 97.1801C105.684 97.4554 106.037 98.2 106.466 98.9753C106.894 99.7507 107.762 100.458 108.142 100.715C108.626 101.158 109.393 102.26 108.588 103.125C107.782 103.989 106.58 103.244 106.081 102.763C105.772 102.424 105.022 100.995 104.495 97.9936Z",
    fill: "url(#paint104_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.305 98.2556C106.171 96.2908 104.343 94.4641 103.571 93.7962C105.369 95.0619 106.471 95.2923 108.229 96.018C109.635 96.5986 110.555 97.3125 110.859 97.5749L111.115 97.8639C111.905 99.3574 111.045 100.117 110.516 100.311C109.919 100.444 108.44 100.22 107.305 98.2556Z",
    fill: "url(#paint105_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5818 26.0098C20.1523 29.0029 21.4068 30.6378 21.9628 31.0811C21.0239 30.6969 18.6596 30.0485 16.7142 30.528C14.7688 31.0074 12.3785 30.4751 11.4111 30.2098C10.6843 29.8849 9.88854 28.7069 10.6201 27.8361C11.3517 26.9653 12.4423 27.3673 12.8961 27.6772C13.2567 27.9564 14.21 28.5954 15.1385 28.9184C16.0669 29.2414 17.3485 29.4897 17.8732 29.5735C18.5705 29.707 20.3645 30.1954 21.9628 31.0811C20.4717 29.9998 19.0518 27.8023 18.5283 26.8387C18.4011 26.5651 18.0367 25.8258 17.5973 25.0567C17.1579 24.2876 16.28 23.5929 15.896 23.3416C15.4053 22.9056 14.6223 21.8145 15.4155 20.9383C16.2088 20.0622 17.4208 20.79 17.9276 21.2635C18.2413 21.5984 19.0113 23.0167 19.5818 26.0098Z",
    fill: "url(#paint106_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7683 25.7885C17.931 27.7366 19.7847 29.5368 20.5661 30.1934C18.7509 28.9539 17.6455 28.7394 15.8771 28.0392C14.4623 27.4791 13.5321 26.7785 13.2251 26.5206L12.9649 26.2353C12.1531 24.7534 13.002 23.9811 13.5278 23.7802C14.1235 23.6379 15.6055 23.8403 16.7683 25.7885Z",
    fill: "url(#paint107_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7398 107.752C94.0074 104.717 93.2463 102.802 92.8323 102.224C93.6309 102.85 95.7286 104.118 97.731 104.188C99.7334 104.257 101.888 105.421 102.746 105.94C103.357 106.451 103.801 107.801 102.86 108.44C101.918 109.078 100.979 108.394 100.627 107.972C100.356 107.605 99.6131 106.73 98.808 106.166C98.0028 105.602 96.8376 105.014 96.3556 104.79C95.7212 104.471 94.1284 103.512 92.8323 102.224C93.9719 103.671 94.7385 106.172 94.9794 107.242C95.0272 107.54 95.1761 108.351 95.389 109.211C95.6019 110.07 96.2571 110.978 96.558 111.325C96.9111 111.878 97.3668 113.141 96.3647 113.768C95.3626 114.394 94.3951 113.364 94.0366 112.77C93.8261 112.362 93.4722 110.788 93.7398 107.752Z",
    fill: "url(#paint108_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3862 108.733C95.799 106.541 94.5066 104.304 93.9339 103.459C95.3422 105.146 96.3471 105.654 97.8575 106.81C99.0658 107.735 99.7697 108.663 99.9947 108.995L100.167 109.34C100.544 110.987 99.5167 111.499 98.956 111.549C98.3441 111.523 96.9735 110.924 96.3862 108.733Z",
    fill: "url(#paint109_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3505 16.2441C30.1268 19.2829 30.9155 21.1867 31.3378 21.7588C30.5303 21.1447 28.4145 19.9065 26.4113 19.8661C24.4081 19.8257 22.2369 18.6928 21.3711 18.1862C20.7532 17.6842 20.2895 16.3405 21.2215 15.6887C22.1536 15.0369 23.1029 15.7075 23.4611 16.1243C23.7371 16.4872 24.4926 17.3513 25.3058 17.9035C26.119 18.4558 27.2926 19.0273 27.7778 19.2441C28.4167 19.5535 30.0232 20.4896 31.3378 21.7588C30.1774 20.3284 29.3747 17.8383 29.1184 16.772C29.0663 16.4749 28.9057 15.6664 28.6803 14.8098C28.455 13.9532 27.7868 13.0549 27.4808 12.7128C27.1197 12.1647 26.6458 10.9081 27.6388 10.2671C28.6318 9.62611 29.6141 10.6428 29.9811 11.2313C30.1974 11.6361 30.5741 13.2053 30.3505 16.2441Z",
    fill: "url(#paint110_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 15.3021C28.309 17.4848 29.6336 19.7034 30.2185 20.5398C28.7859 18.8728 27.7738 18.3795 26.2468 17.2455C25.0252 16.3383 24.308 15.4208 24.0782 15.0922L23.9007 14.7493C23.5002 13.1078 24.5199 12.5815 25.0799 12.5235C25.6921 12.5403 27.0712 13.1194 27.6901 15.3021Z",
    fill: "url(#paint111_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8205 114.398C81.8645 111.535 81.6251 109.488 81.3749 108.823C81.9843 109.634 83.6821 111.402 85.5983 111.988C87.5146 112.573 89.2943 114.255 89.9891 114.978C90.4467 115.63 90.5263 117.049 89.4518 117.422C88.3773 117.795 87.6469 116.891 87.416 116.392C87.2494 115.968 86.7583 114.93 86.1266 114.177C85.4948 113.424 84.5216 112.554 84.1139 112.213C83.5836 111.741 82.2934 110.402 81.3749 108.823C82.1011 110.515 82.1942 113.13 82.1499 114.226C82.119 114.526 82.0529 115.348 82.0361 116.233C82.0193 117.119 82.4171 118.165 82.6181 118.578C82.816 119.204 82.9292 120.542 81.799 120.888C80.6689 121.234 80.0012 119.987 79.8086 119.321C79.7109 118.873 79.7764 117.26 80.8205 114.398Z",
    fill: "url(#paint112_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.123 116.03C83.123 113.761 82.4538 111.265 82.1192 110.301C83.0428 112.295 83.882 113.046 85.0417 114.554C85.9695 115.76 86.4093 116.838 86.5407 117.217L86.618 117.595C86.5556 119.284 85.4309 119.512 84.8764 119.415C84.292 119.232 83.1231 118.298 83.123 116.03Z",
    fill: "url(#paint113_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2752 9.60118C42.2727 12.4785 42.5418 14.5217 42.8016 15.1836C42.1805 14.3814 40.4573 12.6377 38.5328 12.0802C36.6083 11.5228 34.8043 9.86657 34.0992 9.15315C33.6322 8.50832 33.5321 7.0903 34.6011 6.70198C35.6701 6.31365 36.4135 7.2071 36.6516 7.70236C36.8243 8.12442 37.3304 9.15451 37.9729 9.89843C38.6155 10.6424 39.6012 11.4982 40.0138 11.8331C40.5508 12.2973 41.8603 13.6173 42.8016 15.1836C42.051 13.5015 41.9201 10.8885 41.9485 9.79228C41.975 9.49175 42.0292 8.66926 42.0332 7.78353C42.0372 6.8978 41.6243 5.85715 41.4173 5.44755C41.2104 4.8246 41.0779 3.48818 42.2029 3.12603C43.3279 2.76388 44.0136 4.00021 44.2158 4.66363C44.32 5.11058 44.2778 6.72382 43.2752 9.60118Z",
    fill: "url(#paint114_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9493 8.00274C40.9822 10.2713 41.6875 12.7571 42.0359 13.7164C41.0836 11.7354 40.2336 10.997 39.0522 9.50637C38.107 8.31388 37.6517 7.24208 37.5148 6.86519L37.4321 6.48801C37.4701 4.79878 38.5913 4.55435 39.1472 4.64329C39.7342 4.81789 40.9164 5.73422 40.9493 8.00274Z",
    fill: "url(#paint115_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6179 117.477C68.3672 114.982 68.6657 112.943 68.5963 112.235C68.975 113.177 70.1572 115.324 71.8567 116.385C73.5562 117.447 74.84 119.532 75.3238 120.411C75.5971 121.159 75.3067 122.55 74.1723 122.632C73.0379 122.714 72.5664 121.652 72.4725 121.11C72.4214 120.657 72.2155 119.528 71.8002 118.637C71.385 117.746 70.67 116.654 70.3645 116.219C69.9744 115.626 69.0746 113.999 68.5963 112.235C68.8596 114.058 68.2728 116.608 67.9465 117.655C67.839 117.937 67.5625 118.713 67.317 119.564C67.0716 120.416 67.185 121.529 67.2724 121.98C67.3015 122.636 67.0645 123.958 65.8834 123.999C64.7022 124.041 64.3797 122.664 64.3662 121.971C64.3878 121.512 64.8685 119.972 66.6179 117.477Z",
    fill: "url(#paint116_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4196 119.649C69.0067 117.458 69.0063 114.874 68.9327 113.856C69.3086 116.022 69.9249 116.964 70.655 118.72C71.239 120.125 71.3847 121.281 71.4136 121.68L71.3903 122.066C70.893 123.681 69.7476 123.61 69.237 123.373C68.7199 123.045 67.8325 121.841 68.4196 119.649Z",
    fill: "url(#paint117_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4753 6.53388C55.7622 9.05373 55.4933 11.0969 55.5729 11.8034C55.1807 10.8679 53.9674 8.73761 52.2528 7.70103C50.5382 6.66445 49.2243 4.5978 48.7278 3.72617C48.4437 2.98246 48.714 1.58685 49.847 1.48843C50.9801 1.39 51.467 2.44542 51.5688 2.98543C51.6263 3.43781 51.8486 4.56378 52.2767 5.44866C52.7048 6.33354 53.4355 7.41535 53.7473 7.84564C54.1459 8.43305 55.0691 10.047 55.5729 11.8034C55.2832 9.98447 55.8331 7.42662 56.1442 6.37507C56.2477 6.09166 56.5129 5.31121 56.746 4.4567C56.9791 3.6022 56.8496 2.49013 56.7557 2.04091C56.7171 1.38564 56.9349 0.0604493 58.1154 0.00182098C59.2958 -0.0568073 59.6381 1.31486 59.6618 2.00802C59.6467 2.4667 59.1884 4.01403 57.4753 6.53388Z",
    fill: "url(#paint118_radial_2939_38315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6423 4.38792C55.087 6.58766 55.1248 9.1713 55.2131 10.1881C54.8059 8.02811 54.176 7.09489 53.4206 5.34929C52.8163 3.95281 52.654 2.79969 52.6193 2.40021L52.637 2.01447C53.1108 0.392622 54.2572 0.446727 54.7711 0.676512C55.2929 0.997087 56.1977 2.18817 55.6423 4.38792Z",
    fill: "url(#paint119_radial_2939_38315)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2939_38315",
    x: -8,
    y: -8,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2939_38315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2939_38315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2939_38315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 62) rotate(90) scale(62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCardImg);
export default __webpack_public_path__ + "static/media/question_card_img.5155fb0a32982f740538424cc16bcfa8.svg";
export { ForwardRef as ReactComponent };